import angular from 'angular';
import 'angular-bootstrap-calendar';

// Libraries
//import 'angular-bootstrap-calendar/dist/js/angular-bootstrap-calendar-tpls.min.js';

// Translations
import translation from '../../../../../lib/translation';

// Load all services
import '../../../../../lib/service';

// Dependencies
import availabilityModal from '../availabilityModal';

// Component
import component from './calendar.component';

const moduleName = 'staff.dashboardScreen.calendar';
let module = angular.module(moduleName, [
  translation,
  'mwl.calendar',
  'angularMoment',
  availabilityModal.name
]);

module.component('calendar', component)
  .config(function(calendarConfig) {
    calendarConfig.templates.calendarMonthView = 'calendar-month-template.html';
    calendarConfig.templates.calendarMonthCell = 'calendar-month-cell-template.html';
    calendarConfig.templates.calendarMonthCellEvents = 'calendar-month-cell-events-template.html';
    calendarConfig.templates.calendarDayView = 'calendar-day-view-template.html';
    calendarConfig.templates.calendarWeekView = 'calendar-week-view-template.html';
    calendarConfig.templates.calendarSlideBox = 'calendar-slide-box-template.html';

    // Use either moment or angular to format dates on the calendar. Default angular. Setting this will override any date formats you have already set.
    calendarConfig.dateFormatter = 'moment';
  });

export default module;
